export const GLOBAL_STANDARD_SCOPE_CODE = 'default'

// NOTE: 'default' is the restricted jurisdiction that should exist for every organization and can't be deleted
type CanDeletePolicyScope = (code: string) => boolean
export const getCanDeletePolicyScope: CanDeletePolicyScope = code => code !== GLOBAL_STANDARD_SCOPE_CODE
